import axios from "axios";
import { App_Url_New } from "../common/static";
import { UploadOcrDocumentParams } from "../types";

const ocrClient = axios.create({
  baseURL:
    "https://insurance-backend-fastapi-dev-c8bsctfrdqawa5fs.centralindia-01.azurewebsites.net/api/v1",
});

export async function uploadOcrDocument({
  endpointPath = App_Url_New.ApiOcrEndPoint.ExtractDocument,
  fields = {},
  files = [],
  headers = {},
}: UploadOcrDocumentParams) {
  const formData = new FormData();

  Object.entries(fields).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formData.append(key, String(value));
    }
  });

  files.forEach(({ name, file }) => {
    if (file) {
      formData.append(name, file);
    }
  });

  const response = await ocrClient.post(endpointPath, formData, {
    headers: {
      "x-client-id": "nexsys_rd",
      "x-api-key": "NezaSyD1IRFXeEs9RsybLl184QeNat3vDO_jm3g_Nexsys",
      "Content-Type": "multipart/form-data",
      ...headers,
    },
  });

  return response.data;
}
